import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useMediaQuery } from '@shape-construction/hooks/src/useMediaQuery';
import ModalBase from '../ModalBase';
import { breakpoints } from '../utils/breakpoints';
export const ModalRoot = t0 => {
  const $ = _c(17);
  let onClose;
  let open;
  let props;
  let t1;
  let zIndex;
  if ($[0] !== t0) {
    ({
      onClose,
      open,
      zIndex,
      maxWidth: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = onClose;
    $[2] = open;
    $[3] = props;
    $[4] = t1;
    $[5] = zIndex;
  } else {
    onClose = $[1];
    open = $[2];
    props = $[3];
    t1 = $[4];
    zIndex = $[5];
  }
  const maxWidth = t1 === undefined ? "md" : t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = breakpoints.up("md");
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const isLargeScreen = useMediaQuery(t2);
  const fullScreenMode = !isLargeScreen;
  const isPadded = isLargeScreen;
  const hasRoundBorders = isLargeScreen;
  const transition = isLargeScreen ? "fade" : "bottom-to-top";
  const t3 = isLargeScreen ? maxWidth : "none";
  let t4;
  if ($[7] !== fullScreenMode || $[8] !== hasRoundBorders || $[9] !== isPadded || $[10] !== onClose || $[11] !== open || $[12] !== props || $[13] !== t3 || $[14] !== transition || $[15] !== zIndex) {
    t4 = <ModalBase.Root {...props} onClose={onClose} open={open} zIndex={zIndex} fullScreen={fullScreenMode} outsidePad={isPadded} roundBorders={hasRoundBorders} transition={transition} fullWidth={true} maxWidth={t3} />;
    $[7] = fullScreenMode;
    $[8] = hasRoundBorders;
    $[9] = isPadded;
    $[10] = onClose;
    $[11] = open;
    $[12] = props;
    $[13] = t3;
    $[14] = transition;
    $[15] = zIndex;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};
export const ModalContent = ModalBase.Content;
export const ModalTitle = ModalBase.Title;
export const ModalSubTitle = ModalBase.SubTitle;
export const ModalHeader = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ModalBase.Header bottomBorder={true} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const ModalFooter = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ModalBase.Footer topBorder={true} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};